import { render, staticRenderFns } from "./topic_token.vue?vue&type=template&id=61e3151e&vue3"
import script from "./topic_token.vue?vue&type=script&lang=js&vue3"
export * from "./topic_token.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports